import { Box } from "rebass/styled-components";
import styled from "styled-components";

import { ContentItem } from "../ContentItem";
import { SuggestionBadge } from "../../../Components/SuggestionBadge";
import { IContentItem } from "../@types";
import { ClipContext } from "MVVM/Views/ClipExperience/@types";

interface ICombinedFeedContentItemProps {
  item: IContentItem;
  title: string;
  subtextColor?: string;
  reason?: string;
  navigationContext?: ClipContext;
}

export const CombinedFeedContentItem = ({
  item,
  title,
  subtextColor = "chalk",
  reason,
  navigationContext,
}: ICombinedFeedContentItemProps) => {
  return (
    <ContentItemWrapper>
      {reason && (
        <ReasonBadgeOverlay>
          <SuggestionBadge reason={reason} showTooltip={false} />
        </ReasonBadgeOverlay>
      )}
      <ContentItem
        item={item}
        title={title}
        subtextColor={subtextColor}
        navigationContext={navigationContext}
      />
    </ContentItemWrapper>
  );
};

const ContentItemWrapper = styled(Box)`
  position: relative;
  width: 100%;
`;

const ReasonBadgeOverlay = styled(Box)`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 15;

  @media (max-width: 480px) {
    top: 6px;
    left: 6px;
  }
`;
